import React, { useEffect, useState } from "react";
import CustomDropdown from "../../../dropdown/CustomDropdown";
import BarChart from "./charts/BarChart";
import DoughnutChart from "./charts/DoughnutChart";
import LineChart from "./charts/LineChart";
import MetricsData from "./MetricsData";
import { leadsDataCard, comparedYearData, calendarData } from "../adminData";
import moment from "moment";
import { formatDate } from "../../../../utilities/utils";
import DashboardAdminCalendar from "../../../calendar/DashboardAdminCalendar";
import {
  useGetAllLeadsQuery,
  useGetFilteredLeadsQuery,
  useLazyGetAllLeadsQuery,
  useLazyGetFilteredLeadsQuery,
} from "../../../../store/admin/leads";
import GreenChartSvg from "../svgIcons/GreenChartSvg";
import RedChartSvg from "../svgIcons/RedChartSvg";
import { formatDollar } from "../../../../utilities/utils";

const tempData = [
  {
    id: 1,
    name: "All Professionals",
  },
  {
    id: 2,
    name: "Leads",
  },
  {
    id: 3,
    name: "Services",
  },
];
const FinancialMetricsData = ({ metricsData , professions , handleProfessionChange }) => {
  const currentYearRevenue = metricsData.current_year_mtd_revenue?.map(item => item.total)
  const previousYearRevenue = metricsData.previous_year_mtd_revenue?.map(item => item.total)
  const monthLabels = metricsData.current_year_mtd_revenue?.map(item => item.month)
  const [selectedProfession , setSelectedProfession]=useState("")
  const [
    getAllFilteredLeads,
    {
      data: filteredLeads,
      isLoading: filteredLeadsLoader,
      isSuccess: filteredLeadsSuccess,
      isFetching: filteredLeadsFetching,
    },
  ] = useLazyGetFilteredLeadsQuery();
  const currentDate = moment();
  const startOfMonth = currentDate.startOf("month");
  const [calendarOpen, setCalendarOpen] = useState(false);
  const revenueStatistics = {
    "labels": monthLabels,
    percentage: false,
    yearlyBasedStatistics: [{
      color: "#B7C9DA",
      dataSet: currentYearRevenue,
      year: "2024"
    },
    {
      color: "#1E90FE",
      dataSet: previousYearRevenue,
      year: "2026"
    }
    ]
  }


  const [selectRange, setSelectRange] = useState({
    startDate:  moment().format("MM/DD/YYYY"),
    endDate: moment().format("MM/DD/YYYY"),
  });
  const [activeButton, setActiveButton] = useState("30 Days");

  const [selectedCalendarFilter, setSelectedCalendarFilter] =
    useState("Today");
  const [selectedCompareFilter, setSelectedCompareFilter] = useState([
    "Previous period",
  ]);

  const handleClose = () => {
    setCalendarOpen(false);
  };
  const handleOpen = () => {
    setCalendarOpen((prevState) => !prevState);
  };
  const calendarFilterChange = (value) => {
    setSelectedCalendarFilter(value);

    const selectedPeriod =
      calendarData && calendarData?.find((item) => item.text === value)?.period;

    if (selectedPeriod) {
      setSelectRange({
        startDate: selectedPeriod.start,
        endDate: selectedPeriod.end,
      });
    } else {
      setSelectRange({});
    }
  };
  const compareFilterChange = (value) => {
    setSelectedCompareFilter(value);
  };
  const handleCalendarChange = (value, event) => {
    const startDate = formatDate(value[0]);
    const endDate = formatDate(value[1]);
    setSelectRange({ startDate: startDate, endDate: endDate });
  };
  const handleDateFilter = (professionID = null) => {
    const formattedStartDate = moment(
      selectRange.startDate,
      "MM/DD/YYYY"
    ).format("YYYY-MM-DD");
    const formattedEndDate = moment(selectRange.endDate, "MM/DD/YYYY").format(
      "YYYY-MM-DD"
    );
    if (selectedCalendarFilter === "All") {
      getAllFilteredLeads({});
    } else {
      getAllFilteredLeads({
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        professionID:professionID,
        // status_ids: selectedStatus.map((status) => status.id).join(","),
      });
    }
    handleClose()
  };

  const getProfessionNameWithAll =()=>{
    return ["All Professions", ...professions?.filter(spec => spec.searchable && !spec.parent_id).map(data => data.name)];
  }
  
  const updateMatricesDataByProfessionId =(professionName)=>{
    setSelectedProfession(professionName)
    const professionId = professions?.find(profession => profession. name == professionName)?.id;
    handleProfessionChange(professionId)
  }
  
 


  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };

  return (
    <div>
      <div className="flex justify-between items-start md:items-center flex-col md:flex-row gap-5 mb-[14px]">
        <h3 className="text-xl leading-[160%] font-bold text-[#04091E]">
          Financial Metrics
        </h3>
        <CustomDropdown
          options={professions?.length ? getProfessionNameWithAll() : []}
          selectedOption={selectedProfession ? selectedProfession : "All Professions"}
          setSelectedOption={(value)=> updateMatricesDataByProfessionId(value)}
          classes="px-[14px] md:p-5 border border-solid border-[#EBEFF3] rounded-[10px] h-12 bg-white flex items-center justify-between w-[310px]"
          textClasses="inline-flex w-full items-center text-left gap-x-[10px] text-sm md:text-base font-medium text-customGray"
          rightIconClasses="-mr-1 h-6 w-6 text-customGray font-bold"
          menuClasses="absolute left-0 z-10 mt-5 w-full origin-top rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
        />
      </div>
      <div className="p-5 border border-[#EBEFF3] rounded-md bg-white mb-6">
        <div className="flex md:items-center justify-between mb-[30px] flex-col md:flex-row gap-4">
          <h6 className="text-base font-bold flex gap-3 leading-[180%] text-[#04091E]">
            Revenue
            <span className="text-lg font-normal leading-[170%] text-customGray hidden sm:block">
              |
            </span>
            {selectedProfession ? selectedProfession : "All Professions"}
          </h6>
          <div className="flex items-center gap-2 sm:flex-none">
            <DashboardAdminCalendar
              name={"Revenue"}
              calendarFilter={calendarData}
              compareFilter={comparedYearData}
              selectedCalendarFilter={selectedCalendarFilter}
              calendarFilterChange={calendarFilterChange}
              selectedCompareFilter={selectedCompareFilter}
              compareFilterChange={compareFilterChange}
              handleCalendarChange={handleCalendarChange}
              setSelectRange={setSelectRange}
              selectRange={selectRange}
              handleDateFilter={handleDateFilter}
              calendarOpen={calendarOpen}
              setCalendarOpen={setCalendarOpen}
              handleOpen={handleOpen}
              handleClose={handleClose}
            />
          </div>
          {/* <div className="flex items-center gap-2 sm:flex-none">
            <button
              type="button"
              className={`block text-sm font-medium leading-[160%] py-1 px-2 md:px-3 duration-300 cursor-pointer rounded-full ${
                activeButton === "Today" ? "active-button" : ""
              }`}
              style={{
                backgroundColor:
                  activeButton === "Today" ? "black" : "transparent",
                color: activeButton === "Today" ? "white" : "#485868",
              }}
              onClick={() => handleButtonClick("Today")}
            >
              Today
            </button>
            <button
              type="button"
              className={`block text-sm font-medium leading-[160%] py-1 px-2 md:px-3 duration-300 cursor-pointer rounded-full ${
                activeButton === "30 Days" ? "active-button" : ""
              }`}
              style={{
                backgroundColor:
                  activeButton === "30 Days" ? "black" : "transparent",
                color: activeButton === "30 Days" ? "white" : "#485868",
              }}
              onClick={() => handleButtonClick("30 Days")}
            >
              30 Days
            </button>
            <button
              type="button"
              className={`block text-sm font-medium leading-[160%] py-1 px-2 md:px-3 duration-300 cursor-pointer rounded-full ${
                activeButton === "90 Days" ? "active-button" : ""
              }`}
              style={{
                backgroundColor:
                  activeButton === "90 Days" ? "black" : "transparent",
                color: activeButton === "90 Days" ? "white" : "#485868",
              }}
              onClick={() => handleButtonClick("90 Days")}
            >
              90 Days
            </button>
            <button
              type="button"
              className={`block text-sm font-medium leading-[160%] py-1 px-2 md:px-3 duration-300 cursor-pointer rounded-full ${
                activeButton === "180 Days" ? "active-button" : ""
              }`}
              style={{
                backgroundColor:
                  activeButton === "180 Days" ? "black" : "transparent",
                color: activeButton === "180 Days" ? "white" : "#485868",
              }}
              onClick={() => handleButtonClick("180 Days")}
            >
              180 Days
            </button>
          </div> */}
        </div>
        <div className="grid grid-cols-12 gap-6 items-center">
          <div className="col-span-12 xl:col-span-4 grid grid-cols-12 gap-6 xl:block">
            <div className="bg-[#FAFAFB] rounded-md py-[30px] px-6 border border-[#EBEFF3] xl:mb-5 text-center col-span-12 sm:col-span-6">
              <div className="flex items-center justify-center gap-2.5">
                <span className="text-[30px] xl:text-[40px] leading-[48px] font-bold text-[#191919] tracking-tight">
                 {formatDollar(metricsData?.revenue_in_credits)}
                </span>
                <span className="w-[1px] bg-[#BEC2C5] h-6"></span>
                <span className={`text-sm font-bold leading-[160%] ${metricsData?.revenue_in_credits_change?.trim().startsWith('-') ? "text-[#EF2121]" : "text-[#16CA7C]" }  flex items-center gap-1.5`}>{metricsData?.revenue_in_credits_change?.trim().startsWith('-') ?  <RedChartSvg /> : <GreenChartSvg />}{metricsData?.revenue_in_credits_change}</span>
              </div>
              <div className="w-[30px] h-[3px] bg-[#16CA7C] my-2 mx-auto"></div>
              <p className="text-base leading-[160%] font-medium text-[#485868]">
                Revenue in Credits Spent
              </p>
            </div>
            <div className="bg-[#FAFAFB] rounded-md py-[30px] px-6 border border-[#EBEFF3] text-center col-span-12 sm:col-span-6">
              <div className="flex items-center justify-center gap-2.5">
                <span className="text-[30px] xl:text-[40px] leading-[48px] font-bold text-[#191919] tracking-tight">
                {formatDollar(metricsData?.credit_pack_revenue)}
                </span>
                <span className="w-[1px] bg-[#BEC2C5] h-6"></span>
                <span className={`text-sm font-bold leading-[160%] ${metricsData?.credit_pack_revenue_change?.trim().startsWith('-') ? "text-[#EF2121]" : "text-[#16CA7C]" }  flex items-center gap-1.5`}>{metricsData?.credit_pack_revenue_change?.trim().startsWith('-') ?  <RedChartSvg /> : <GreenChartSvg />}{metricsData?.credit_pack_revenue_change}</span>
              </div>
              <div className="w-[30px] h-[3px] bg-[#16CA7C] my-2 mx-auto"></div>
              <p className="text-base leading-[160%] font-medium text-[#485868]">
                  Credit Pack Revenue <br />(New Sales and Renewals)
              </p>
            </div>
          </div>
          <div className="col-span-12 xl:col-span-8">
            <LineChart chartData={revenueStatistics} />
          </div>
        </div>
      </div>
      <div className="p-5 border border-[#EBEFF3] rounded-md bg-white mb-6">
        <div className="flex items-center justify-between mb-8">
          <h6 className="text-base font-bold flex gap-3 leading-[180%] text-[#04091E]">
            Customer Lifetime Value
            <span className="text-lg font-normal leading-[170%] text-customGray hidden sm:block">
              |
            </span>
            {selectedProfession ? selectedProfession : "All Professions"}
          </h6>
        </div>
        <div className="block sm:grid grid-cols-12 gap-14 items-center">
          <div className="col-span-12 xl:col-span-5">
            <div className="bg-[#FAFAFB] rounded-md py-[30px] px-6 border border-[#EBEFF3] text-center">
              <span className="text-xl font-bold leading-[180%] text-[#191919] mb-[30px] block">
                TOTAL CUSTOMERS: {metricsData?.total_customers}
              </span>
              <div className="max-w-[280px] w-full mx-auto">
                <DoughnutChart metricsData={metricsData} />
              </div>
            </div>
          </div>
          <div className="col-span-12 xl:col-span-7">
            <BarChart metricsData={metricsData} />
          </div>
        </div>
      </div>
      <MetricsData metricsData={metricsData} />
    </div>
  );
};

export default FinancialMetricsData;
